module.exports = __webpack_public_path__ + "img/icon-information.aa0f591c.svg";